import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { McpServerCreateRequest } from "../../types";

type NameFormFieldProps = {
  control: Control<McpServerCreateRequest>;
  autoFocus?: boolean;
  /** Hide the inline helper when the surrounding layout already explains the field. */
  hideDescription?: boolean;
};

export function NameFormField({
  control,
  autoFocus,
  hideDescription,
}: NameFormFieldProps) {
  return (
    <FormField
      control={control}
      name="name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Name</FormLabel>
          <FormControl>
            <Input
              {...field}
              autoFocus={autoFocus}
              placeholder='e.g. "Inbox assistant"'
            />
          </FormControl>
          {hideDescription ? null : (
            <FormDescription>
              A recognizable name, shown in your dashboard and connection
              instructions.
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
